import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import {
    EstadosTurnosAtencion,
    useActualizarTurnoAtencionMutation,
    useGetHabitacionTurnosAtencionQuery,
} from "src/gql/schema"
import { useProfile } from "src/shared/hooks/useProfile"
import useSnackbar from "src/shared/hooks/useSnackbar"

// Turno de la lista de espera con el que se llegó a la venta, pasa a "en curso" al entrar
const useListaEspera = () => {
    const location = useLocation()
    const { hotel_id } = useProfile()
    const { showSnackbar } = useSnackbar()
    const [actualizarListaEspera] = useActualizarTurnoAtencionMutation()

    const turnoAtencionId = location?.state?.folio_turno_id
    const { data: dataListaEspera } = useGetHabitacionTurnosAtencionQuery({
        variables: {
            hotel_id,
            turno_atencion_id: [turnoAtencionId],
        },
        skip: !turnoAtencionId,
    })
    const folioListaEspera = dataListaEspera?.turnos_atencion?.[0]?.folio_turno

    /** función para actualizar el estado del turno en lista de espera */
    const updateListaEspera = async (turno_atencion_id: string, estado: EstadosTurnosAtencion, renta_id?: string) => {
        try {
            await actualizarListaEspera({
                variables: {
                    input: {
                        turno_atencion_id,
                        estado,
                        ...(renta_id && { renta_id }),
                    },
                },
            })
        } catch (error) {
            showSnackbar({
                title: "Error al atender turno",
                text: `¡Ups! Ocurrió un error al atender el turno  **${folioListaEspera}**`,
                status: "error",
            })
        }
    }

    useEffect(() => {
        const turno = dataListaEspera?.turnos_atencion?.[0]
        if (!turno) return

        if (turnoAtencionId && turno.estado === EstadosTurnosAtencion.EnEspera) {
            updateListaEspera(turnoAtencionId, EstadosTurnosAtencion.EnCurso)
        }
    }, [dataListaEspera, turnoAtencionId])

    return { turnoAtencionId, folioListaEspera, updateListaEspera }
}

export default useListaEspera
